<template lang="pug">
  v-row
    template(v-if="value")
      v-col(cols=12)
        v-autocomplete(
          :value="value['search[group_id]']"
          :items="course.groups"
          item-text="short_name"
          item-value="id"
          label="Группа"
          hide-details
          rounded
          filled
          clearable
          @click:clear="searchKeys['search[group_id]'] = null"
          @input="searchKeys['search[group_id]'] = $event"
        ).mt-4
        v-sheet(color="grey lighten-3").mt-4.sdo-radius.pa-4
          span Минимальное количество завершенных тем
          v-slider.mt-9(
            :value="value['search[passed_course_units_min]']"
            thumb-label="always"
            ticks
            hide-details
            :max="course.course_units_count"
            @change="searchKeys['search[passed_course_units_min]'] = $event"
          )
        v-checkbox(
          :input-value="value['search[passed_course_tasks]']"
          label="Выполнены все курсовые"
          rounded filled
          hide-details
          @change="searchKeys['search[passed_course_tasks]'] = $event"
        )
      v-col(cols=12)
        v-expand-transition
          v-btn(
            v-if="hasFilters"
            block
            depressed
            rounded
            large
            @click="reset"
          )
            span Сбросить
            v-icon(right) mdi-close
</template>

<script>
export default {
  name: 'EnrollmentAttestationFilters',
  props: {
    value: { type: Object, default: () => ({}) },
    course: { type: Object, required: true },
  },
  data() {
    return {
      searchKeys: {
        'search[full_name]': null,
        'search[passed_course_tasks]': null,
        'search[passed_course_units_max]': null,
        'search[passed_course_units_min]': null,
      },
    };
  },
  computed: {
    hasFilters() {
      return Object.values(this.searchKeys).find((v) => v);
    },
  },
  watch: {
    searchKeys: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true,
    },
  },
  created() {
    if (!this.value) this.$emit('input', this.searchKeys);
    else this.searchKeys = { ...this.value };
  },
  methods: {
    reset() {
      Object.entries(this.searchKeys).forEach(([key]) => {
        this.searchKeys[key] = null;
      });
    },
  },
};
</script>
